import styled from '@emotion/styled';
import { Link as RouterLink } from 'react-router-dom';
import { Drawer as AntDrawer } from 'antd';

export const Div = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
  margin-top: 0;
  position: relative;
  z-index: 2;
  padding-top: 56px;
`;

export const Link = styled(RouterLink)`
  margin-bottom: 32px;
`;

export const LogoLink = styled(RouterLink)`
  display: block;
`;

export const LogoImg = styled.img`
  max-width: 80px;
  max-height: 37px;
`;

export const Drawer = styled(AntDrawer)`
  .ant-drawer-body {
    position: relative;
    padding: 30px 24px 0 38px;
    background: ${({ theme }) => theme.colors.secondaryDark};
  }
`;

export const DesktopContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) =>
    `80px ${theme.spacings[7]} 80px ${theme.spacings[7]}`};
  background: ${({ theme }) => theme.colors.secondaryDark};
  ${({ theme }) => theme.media.mobile} {
    display: none;
  }
`;

export const MobileContainer = styled.div`
  display: none;

  ${({ theme }) => theme.media.mobile} {
    display: flex;
  }
  justify-content: space-between;
  padding: 40px 40px 0;
`;
